<ma-task-modal
  [task]="state.task"
  [taskInfos]="state.taskInfos"
  [pictureId]="state.machinePictureId"
  [details]="state.details"
>
</ma-task-modal>
